<template>
  <div style="display: none">teleportTo: {{ teleportTo }}</div>
  <Teleport to=".rhg-menu-secondary__button">
    <div class="tailwind" style="display: flex; align-items: center; height: 100%">
      <button v-if="isExpanded" class="menu-collapse-button" @click="onCollapse">
        <FontIcon name="arrow-up" />
      </button>
      <Button v-else small @click="onExpand">{{ useTranslate('sbrBook') }}</Button>
    </div>
  </Teleport>
  <Teleport :to="teleportTo">
    <div class="tailwind" style="width: 100%">
      <PropertySearchbar :config="config" />
    </div>
  </Teleport>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import {
  PropertySearchbar,
  Button,
  useTranslate,
  FontIcon,
  useScreen
} from '@common/lib-vue-common'

defineProps({
  config: Object
})

const teleportTo = ref('#searchbar-inside-menu')

const { isXs, isSm } = useScreen('xs', 'sm', 'md', 'lg', 'xl', '2xl')
const isMobile = computed(() => isXs.value || isSm.value)
const isExpanded = ref(false)

const onExpand = () => {
  const sb = document.querySelector('#searchbar-inside-menu')
  if (!sb) return
  teleportTo.value = '#searchbar-inside-menu'
  sb.style.display = 'block'
  isExpanded.value = true
}

const onCollapse = () => {
  const sb = document.querySelector('#searchbar-inside-menu')
  if (!sb) return
  teleportTo.value = '#searchbar-inside-menu'
  sb.style.display = 'none'
  isExpanded.value = false
}

const placeSb = () => {
  const button = document.querySelector('.rhg-menu-secondary__button')

  if (isMobile.value) {
    if (teleportTo.value !== '#searchbar') {
      teleportTo.value = '#searchbar'
    }

    button.style.display = 'none'
  } else {
    if (teleportTo.value !== '#searchbar-inside-menu') {
      teleportTo.value = '#searchbar-inside-menu'
    }

    button.style.display = 'flex'
  }
}

onMounted(async () => {
  console.log('*** MenuFixedButton')
  // const menu = document.querySelector('.rhg-menu-secondary');
  const button = document.querySelector('.rhg-menu-secondary__button')

  // if (menu) {
  //   menu.classList.add('rhg-menu-secondary--sticky');
  // }

  if (button) {
    placeSb()
    window?.addEventListener('resize', placeSb)
  }
})
</script>

<style lang="css" scoped>
.menu-collapse-button {
  width: 36px;
  height: 36px;
  border-radius: 100%;
  border: solid 2px white;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}
</style>
